var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys-version"},[_vm._v(" Version: v"+_vm._s(_vm.latestNoteVersion)),_c('br'),_vm._v(" ©2023 Blue Planet Training, Inc. All rights reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }